import problemsolving from './problemsolving'
import quickaction from './quickaction'
import rev from './rev'
import stream from './stream'
import organization from './organization'
import country from './country'
import routine from './routine'
import situationType from './situationType'

const api = {
  problemsolving,
  quickaction,
  rev,
  stream,
  organization,
  country,
  routine,
  situationType,
}

export default api
